import React from "react";
import TWITTER from "../images/twitter-brands.svg";
import INSTAGRAM from "../images/instagram-brands.svg";

const Footer = ({ inIndex }) => {
  return (
    <>
      <div
        className={`relative bottom-0 ${
          inIndex ? "bg-gold" : "bg-slate-100"
        } box-border w-full h-60 z-40`}
      ></div>
      <div
        className={`relative bottom-0 bg-navy box-border w-full py-10 px-4 z-50`}
      >
        <div className="container">
          <a
            className="flex flex-row mt-5 mb-3"
            href="https://twitter.com/EuTuCarnival"
          >
            <img className="w-7 mr-2" src={TWITTER} alt="logo" />
            <span className="font-bold text-white underline">Twitter</span>
          </a>
          <a
            className="flex flex-row mb-7"
            href="https://instagram.com/euphonium_tuba_carnival"
          >
            <img className="w-7 mr-2" src={INSTAGRAM} alt="logo" />
            <span className="font-bold text-white underline">Instagram</span>
          </a>
          <p className="text-white text-sm">© 2022 Euph & Tuba Carnival</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
